export enum BtnModifier {
  ACTIVE = 'btn--active',
  MICRO_INTERACTION = 'btn--micro-interaction',
  MINOR_ACTION_ACTIVATED = 'btn--minor-action-activated',
  MINOR_ACTION_ACTIVATED_BLUE = 'btn--minor-action-activated-blue',
  MINOR_ACTION_ACTIVATED_RED = 'btn--minor-action-activated-red',
  MINOR_ACTION_ACTIVATED_PETROL = 'btn--minor-action-activated-petrol',
  MINOR_ACTION_FAILED = 'btn--minor-action-failed',
  MINOR_ACTION_BUSY = 'btn--minor-action-busy',
  MINOR_ACTION = 'btn--minor-action',
  SINGLE_ACTION = 'btn--single-action',
  SINGLE_ACTION_YES = 'btn--single-action-yes',
  SINGLE_ACTION_NO = 'btn--single-action-no',
  TRANSPARENT = 'btn--transparent',
  TEXT = 'btn--text',
  WHITE = 'btn--white',
  WHITE_BACKGROUND_FOR_DISABLED_PAGE_STATE = 'btn--white-background-for-disabled-page-state',
  MARGIN = 'btn--margin',
  MARGIN_LEFT = 'btn--margin-left',
  PULL_RIGHT = 'btn--pull-right',
  INVERTED = 'btn--inverted',
  ROUND = 'btn--round',
  BIG = 'btn--big',
  INPUT_GROUP = 'btn--input-group',
  GROW = 'btn--grow',
  TOGGLE = 'btn--toggle',
}
